import { RETRIEVE_APPS } from "../actions/apps/types";
import { AppsState } from "./state";
import { AnyAction } from "redux";
import { Reducer } from "react";

const initialState: AppsState = {
    data: [],
    numberOfRecords: 0,
};

const appsReducer: Reducer<AppsState, AnyAction> = (state = initialState, action: AnyAction) => {
    const { type, payload } = action;
    switch (type) {
        case RETRIEVE_APPS:
            return {
                ...state,
                data: payload.data,
                numberOfRecords: payload.total_records_available,
            };

        default:
            return state;
    }
};

export default appsReducer;
